import {ReactNode, Suspense} from 'react';
import {Box, Container, Skeleton} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {FullScreenModal, FullScreenModalTitle} from '@/shared/components/ui/Modal';
import {UseModal} from '@/shared/hooks/useModal';

interface ImageProtocolCaptureModalProps {
  modal: UseModal;
  children: ReactNode;
}

export default function ImageProtocolCaptureModal({
  modal,
  children
}: ImageProtocolCaptureModalProps) {
  const {t} = useTranslation(['shared/imageProtocol']);

  return (
    <FullScreenModal
      isOpened={modal.isOpened}
      onClose={modal.close}
      title={<FullScreenModalTitle>{t('shared/imageProtocol:modalTitle')}</FullScreenModalTitle>}
      id="imageProtocolCaptureModal"
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: 'calc(100vh - 64px - 32px)',
          mx: -2,
          mb: -2
        }}
      >
        <Suspense
          fallback={
            <Container maxWidth="xl" sx={{py: 2}}>
              <Skeleton variant="rectangular" width="100%" height={60} sx={{mb: 2}} />
              <Skeleton variant="rectangular" width="100%" height={400} />
            </Container>
          }
        >
          {children}
        </Suspense>
      </Box>
    </FullScreenModal>
  );
}
